import { Badge } from "@/components/ui/badge"
import { bidLifecycleOf, bidPositionLabel, type LifecycleSource } from "@/lib/bid-lifecycle"
import { cn } from "@/lib/utils"

interface BidStagePillProps {
  bid: LifecycleSource
  className?: string
}

/**
 * Where a bid is, as one quiet pill (R4): the stage for an active bid,
 * "Submitted" once lodged, the outcome once closed, "Lead" for a lead. Won is
 * the one coloured state; every other closed outcome reads muted. Used on Home,
 * the Bids table, the bid header and the stage control.
 */
export function BidStagePill({ bid, className }: BidStagePillProps) {
  const position = bidLifecycleOf(bid)
  const isWon = position.lifecycle === "closed" && position.outcome === "won"
  const isClosed = position.lifecycle === "closed"
  return (
    <Badge
      variant={isWon ? "success" : "secondary"}
      dot={false}
      className={cn(
        "shrink-0 whitespace-nowrap px-2 text-[11px] font-normal",
        !isWon && (isClosed ? "text-muted-foreground" : "text-foreground"),
        className
      )}
      data-testid="bid-stage-pill"
      data-lifecycle={position.lifecycle}
    >
      {bidPositionLabel(position)}
    </Badge>
  )
}
